import styled from 'styled-components';

const BlockLeftWrapper = styled.section`
  padding: 40px 0 40px 0;
  
  .normal-text {
    font-family: 'Roboto', sans-serif;
    line-height: 2;
    color: #343d48cc;
    
    a {
    color: #343d48cc;
    text-decoration: underline;
    }
  }
  
  .info-sec-container {
    @media (min-width: 993px) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
    @media (max-width: 768px) and (min-width: 768px) {
      top: 40%;
    }
    @media (max-width: 767px) {
      padding-bottom: 40px;
    }

    .image_area {
      background-position: bottom left;
      background-size: contain;
      background-repeat: no-repeat;
      padding: 50px 0 60px 0;
      @media (max-width: 767px) {
        padding-top: 0;
      }
    }
  }
`;

export default BlockLeftWrapper;
